"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompleteBinaryWriteImpulse = void 0;
var CompleteBinaryWriteImpulse = /** @class */ (function () {
    function CompleteBinaryWriteImpulse(uri, uploadId, chunks) {
        this.uri = uri;
        this.uploadId = uploadId;
        this.chunks = chunks;
    }
    return CompleteBinaryWriteImpulse;
}());
exports.CompleteBinaryWriteImpulse = CompleteBinaryWriteImpulse;
//# sourceMappingURL=CompleteBinaryWriteImpulse.js.map